import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CaseTask } from 'app/outbox/outbox.component';
import { TimePickerRanges } from 'app/outbox/transfer-models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import * as api from '../../shared/api/apihandler';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { DateUtilities } from 'app/shared/utilities/dateUtilities';

@Component({
  selector: 'case-task-create',
  templateUrl: './case-task-create.component.html'
})
export class CaseTaskCreateComponent implements OnInit, OnChanges, OnDestroy {
  @Input() caseId;
  @Input() customerId;
  @Input() singleTask = true; // to do at later date
  @Input() showTaskList = true;
  companyInfo;
  companyUsers;
  subscriptions: SubscriptionObject = {};
  bsConfig = DateUtilities.bsConfig;
  newTask = new NewTask();
  taskDate: Date | null = null;
  caseTask;
  caseTasks;
  time = new TimePickerRanges();

  updating = false;
  constructor(private http:HttpClient, private sharedData: SharedDataService) {}

  ngOnInit(): void {
    this.subscriptions['companyInformation'] = this.sharedData.companyInformation().subscribe(data => this.companyInfo = data);
    this.subscriptions['companyUsers'] = this.sharedData.companyUsers().subscribe(data => this.companyUsers = data);
  }

  ngOnDestroy(): void {
    for (let x of Object.keys(this.subscriptions)) { this.subscriptions[x].unsubscribe() }
  }

  ngOnChanges(changes: SimpleChanges): void { if(changes.caseId && !!changes.caseId.currentValue) this.getTasks(); }

  getTasks(){
    if (this.caseId != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.http.get(api.jubloApi + 'api/Website/Case/GetCaseTasks/' + this.caseId, { headers }).subscribe({
        next: (data: Array<CaseTask>) => { this.caseTask = data[0]; }
      });
    }
  }

  createTask() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if(!this.caseTask){
      this.http.post(api.jubloApi + 'api/Website/Case/CreateCaseTask/' + this.caseId, {
        customerId: this.customerId,
        fitterId: this.newTask.assignedTo,
        startTime: this.newTask.startTime(),
        endTime: this.newTask.endTime()
      }, { headers }).subscribe({
        complete: () => this.getTasks()
      });
    } else {
      this.http.put(api.jubloApi + 'api/Website/Case/EditTask/' + this.caseTask.taskId, {
        fitterId: this.newTask.assignedTo,
        startTime: this.newTask.startTime(),
        endTime: this.newTask.endTime()
      }, { headers }).subscribe({
        complete: () => this.getTasks()
      });
    }
  }

  deleteTask(){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.delete(api.jubloApi + 'api/Website/Case/RemoveTask/' + this.caseTask.taskId, { headers }).subscribe({
      complete: () => this.caseTask = null
    });
  }

}

class NewTask{
  date: string;
  time: string = '08:00';
  duration: string;
  hours: string = '1';
  minutes: string = '00';
  assignedTo:string = null;
  startTime():string{
    return DateUtilities.mergeDateAndTime(new Date(this.date), this.time).toISOString();
  }
  endTime():string{
    let start = new Date(this.startTime());
    let duration = +this.hours * 60 + +this.minutes;
    return new Date(start.setMinutes(start.getMinutes() + duration)).toISOString();
  }
}